import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy
} from "firebase/firestore";
import "./RechargeRequests.css";

export default function RechargeRequests() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    async function load() {
      const q = query(
        collection(db, "rechargeRequests"),
        orderBy("requestedAt", "desc")
      );
      const snapshot = await getDocs(q);
      setRequests(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
    }
    load();
  }, []);

  const updateStatus = async (req, newStatus) => {
    const ref = doc(db, "rechargeRequests", req.id);
    await updateDoc(ref, { status: newStatus });
    setRequests(rs =>
      rs.map(r => (r.id === req.id ? { ...r, status: newStatus } : r))
    );
  };

  const handleDelete = async id => {
    await deleteDoc(doc(db, "rechargeRequests", id));
    setRequests(prev => prev.filter(r => r.id !== id));
  };

  return (
    <div className="recharge-requests">
      <h2>Recharge Requests</h2>
      <table>
        <thead>
          <tr>
            <th>User</th>
            <th>Provider</th>
            <th>Plan</th>
            <th>Coins Used</th>
            <th>Phone Number</th>
            <th>Requested At</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {requests.length === 0 && (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No requests.
              </td>
            </tr>
          )}
          {requests.map(r => (
            <tr key={r.id}>
              <td>{r.user}</td>
              <td>{r.provider}</td>
              <td>{r.plan}</td>
              <td>{r.coinsUsed}</td>
              <td>{r.number}</td>
              <td>
                {r.requestedAt?.toDate
                  ? r.requestedAt.toDate().toLocaleString()
                  : r.requestedAt}
              </td>
              <td>{r.status}</td>
              <td>
                {r.status === "Pending" ? (
                  <>
                    <button onClick={() => updateStatus(r, "Completed")}>
                      ✅ Approve
                    </button>
                    <button onClick={() => updateStatus(r, "Rejected")}>
                      ❌ Reject
                    </button>
                  </>
                ) : (
                  <em>{r.status}</em>
                )}
               <button className="delete-btn" onClick={() => handleDelete(r.id)}>
  🗑️ Delete
</button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
